import $ from "jquery";
import "jquery-validation";
import "jquery-validation-unobtrusive";
import "lazysizes";
import "mmenu-light";
import objectFitImages from "object-fit-images";
import "picturefill";
import "responsive-bp/build/responsive.js";
import svg4everybody from "svg4everybody";
import carousel from "./carousel";
import filter from "./filter";
import masonry from "./masonry";
import polyfills from "./polyfills";
import uiHelpers from "./ui-helpers";
import ventrata from "./ventrata";
import "@accessible360/accessible-slick";

polyfills.init();

svg4everybody();

// include any plugin initialisation here
// any custom JS that needs to be written should be modular (and in a separate file), possibly done as a jQuery plugin or some other modular form, and initialised here like the other plugins
$(".no-js").removeClass("no-js");

// Send scrolling events to Google Analytics http://scrolldepth.parsnip.io/
if (typeof $.scrollDepth === "function") {
  $.scrollDepth();
}

// Carousels
if (
  $(".js-horizontal-carousel").length ||
  $(".js-vertical-carousel").length ||
  $(".js-ticket-carousel").length
) {
  carousel.init();
}

// Masonry
if ($(".js-masonry-layout").length) {
  masonry.init();
}

// Tag Filter
if ($(".js-filters").length) {
  filter.init();
}

// mmenu
const menuElement = document.querySelector("#menu");
if (menuElement) {
  const menu = new globalThis.MmenuLight(menuElement);
  menu.navigation();
  const drawer = menu.offcanvas({ position: "right" });

  const menuLink = document.querySelector('a[href="#menu"]');
  if (menuLink) {
    menuLink.addEventListener("click", evnt => {
      evnt.preventDefault();
      if (document.body.classList.contains("mm-ocd-opened")) {
        drawer.close();
      } else {
        drawer.open();
      }
    });
  }
}

// Full width element handling
$(".js-fw-element").each(function () {
  $(this)
    .closest(".content-panel__row")
    .addClass("no-flex");
});

// Accordion
const accordions = document.getElementsByClassName("accordion__title");
// tslint:disable-next-line
for (let i = 0; i < accordions.length; i++) {
  accordions[i].addEventListener("click", function () {
    this.classList.toggle("is-open");
    const content = this.nextElementSibling;
    content.classList.toggle("child-is-open");
    if (
      content.style.maxHeight ||
      content.classList.contains("child-is-default-open")
    ) {
      // accordion is currently open, so close it
      content.style.maxHeight = null;
    } else {
      // accordion is currently closed, so open it
      content.style.maxHeight = content.scrollHeight + "px";
    }
    content.classList.remove("child-is-default-open");
  });
}

// Timetables - Horizontal scrolling
const timetables = document.querySelectorAll(".js-scrollable");

let isDown = false;
let startX;
let scrollLeft;

timetables.forEach(slider => {
  if (slider instanceof HTMLElement) {
    slider.addEventListener("mousedown", e => {
      isDown = true;
      slider.classList.add("active");
      startX = e.pageX - slider.offsetLeft;
      scrollLeft = slider.scrollLeft;
    });
    slider.addEventListener("mouseleave", () => {
      isDown = false;
      slider.classList.remove("active");
    });
    slider.addEventListener("mouseup", () => {
      isDown = false;
      slider.classList.remove("active");
    });
    slider.addEventListener("mousemove", e => {
      if (!isDown) {
        return;
      }
      e.preventDefault();
      const x = e.pageX - slider.offsetLeft;
      const walk = x - startX;
      slider.scrollLeft = scrollLeft - walk;
    });
  }
});

// Timetables - Route classes
$(".timetable").each(function () {
  $(this)
    .find("table thead tr th")
    .each(function (i) {
      const route = $(this)
        .text()
        .toLowerCase();

      if (route.match("^rb")) {
        $(this).addClass("is-route " + route);
        $(this)
          .closest("table")
          .find("tbody tr td:nth-child(" + (i + 1) + ")")
          .addClass(route + " count-" + i);
      }
    });
});

objectFitImages();
uiHelpers.init();
ventrata.init();

function setCookie(name: string, value: string, days: number) {
  const expires = new Date(Date.now() + days * 86400000).toUTCString();
  document.cookie = `${name}=${encodeURIComponent(
    value
  )}; expires=${expires}; path=/`;
}

function getCookie(name: string): string | null {
  const cookies = document.cookie.split("; ");
  for (const cookie of cookies) {
    const [key, value] = cookie.split("=");
    if (key === name) {
      return decodeURIComponent(value);
    }
  }
  return null;
}

document.addEventListener("DOMContentLoaded", () => {
  const closeBtn = document.getElementById("close-popup");
  const popup = document.getElementById("site-popup");
  const popupLink = document.querySelector(
    ".js-site-popup-link"
  ) as HTMLAnchorElement | null;

  if (popup && getCookie("sitePopupDismissed") !== "true") {
    popup.classList.remove("site-popup__hidden");
  }

  if (closeBtn && popup) {
    closeBtn.addEventListener("click", () => {
      popup.classList.add("site-popup__hidden");
      setCookie("sitePopupDismissed", "true", 30);
    });
  }

  if (popupLink && popup) {
    popupLink.addEventListener("click", () => {
      popup.classList.add("site-popup__hidden");
      setCookie("sitePopupDismissed", "true", 30);
    });
  }

  // Umbraco Forms: Prevent multiple submits
  document
    .querySelectorAll('.umbraco-forms-form input[type="submit"]')
    .forEach(btn => {
      btn.addEventListener("click", () => {
        const form = (btn as HTMLInputElement).closest("form");
        if (form) {
          const $form = $(form);
          if ($form.valid && $form.valid()) {
            (btn as HTMLInputElement).disabled = true;
            form.submit();
          }
        }
      });
    });
});
